import TimelineMessageCard from '../TimelineMessageCard';

const ComentariosHistorialList = ({ comentarios = [] }) => {
    if (!comentarios.length) {
        return (
            <span style={{ color: '#9e9e9e', fontSize: '0.85rem' }}>
                Sin comentarios registrados.
            </span>
        );
    }

    return (
        <div className="d-flex flex-column" style={{ gap: 10 }}>
            {comentarios.map((item) => (
                <TimelineMessageCard
                    key={item.id}
                    badge={item.etiqueta}
                    usuario={item.usuario}
                    fechaHora={item.fecha_hora}
                    body={item.comentario}
                />
            ))}
        </div>
    );
};

export default ComentariosHistorialList;
